export default __webpack_public_path__ + "static/media/low_localization.d4ea6bcd.svg";